module.exports = __webpack_public_path__ + "img/dieteticien-h.4c0635b1.jpg";